import { render, staticRenderFns } from "./Scheduling.vue?vue&type=template&id=72fd8ace"
import script from "./Scheduling.vue?vue&type=script&lang=js"
export * from "./Scheduling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports